// extracted by mini-css-extract-plugin
export default {"cell_styles":"invoiceTable_cell_styles__PLRO+","id_container":"invoiceTable_id_container__R3Iz3","annullata":"invoiceTable_annullata__zWa5z"};